<div class="container">
  <div class="row">
    <div class="van-integrations-description">
      <div class="van-integrations-description-inner">
        <h1>{{ 'DropboxIntegrationWelcomeTitle' | translate }}</h1>
        <p>{{ 'DropboxIntegrationWelcomeMessage' | translate }}</p>
        <a class="abx-button abx-button-main abx-frame-main-footer-button button action" href="https://www.dropbox.com/home/">{{ 'DropboxIntegrationGoToDropbox' | translate }}</a>
      </div>
    </div>
  </div>
</div>
